export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Line from"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["symbols"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invalid value"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Required Field"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check the fields"])}
}